import { AnalyticsEvent } from "./types";

export const createUIAnalyticsEvent = {
  errorPage: {
    viewed: (
      errorMessage?: string,
      errorType: "application_error" | "api_error" = "application_error",
      statusCode?: number
    ): AnalyticsEvent => ({
      name: "error_page_view",
      payload: {
        error_type: errorType,
        error_message: errorMessage,
        status_code: statusCode
      }
    })
  },
  dialog: {
    opened: (analyticId?: string): AnalyticsEvent => ({
      name: "info_dialog_opened",
      payload: { value: analyticId }
    })
  },
  tooltip: {
    opened: (analyticId: string): AnalyticsEvent => ({
      name: "tooltip_opened",
      payload: { value: analyticId }
    })
  },
  radio: {
    clicked: (analyticId: string): AnalyticsEvent => ({
      name: "radio_clicked",
      payload: { value: analyticId }
    })
  },
  checkbox: {
    clicked: (
      check_id: string,
      value: boolean,
      analyticId: string
    ): AnalyticsEvent => ({
      name: "checkbox_clicked",
      payload: { check_id, value, analyticId }
    })
  },
  select: {
    changed: (analyticId: string, selectedValue: string): AnalyticsEvent => ({
      name: "select_value_changed",
      payload: { value: analyticId, selectedValue }
    })
  },
  dropdown: {
    opened: (analyticId: string, open?: boolean): AnalyticsEvent => ({
      name: "dropdown_open_changed",
      payload: { value: analyticId, open }
    }),
    itemSelected: (
      analyticId: string,
      type: string,
      checked?: boolean | "indeterminate"
    ): AnalyticsEvent => ({
      name: `dropdown_item_type_${type}_selected`,
      payload: { value: analyticId, checked }
    })
  },
  tab: {
    activated: (analyticId: string): AnalyticsEvent => ({
      name: "tab_active",
      payload: { value: analyticId }
    })
  },
  search: {
    typed: (analyticId: string, query: string): AnalyticsEvent => ({
      name: "search_query_typed",
      payload: { value: analyticId, query }
    }),
    cleared: (analyticId: string): AnalyticsEvent => ({
      name: "search_query_cleared",
      payload: { value: analyticId }
    })
  },
  logs: {
    unavailable: (region?: string, regionLabel?: string): AnalyticsEvent => ({
      name: "logs_unavailable_view",
      payload: { region, region_label: regionLabel }
    })
  }
};
